import Img from 'gatsby-image';
import { Link } from 'gatsby';
import React from 'react';

const ImageTextSection = ({
	imgSrc,
	imgAlt,
	sectionTitle,
	undertext,
	linkTo,
	linkText,
	order,
	hideHr,
	btnId,
	skipLeft
}) => {
	return (
		<>
			<div className="row d-flex my-5 mx-md-5 px-lg-5">
				<div className={'col-12 p-0 m-0 col-lg-6 ' + (order && 'order-lg-1')}>
					<div style={{ maxHeight: '700px' }}>
						<Img
							fluid={imgSrc}
							style={{ maxHeight: '700px', left: skipLeft ? '0%' : '-13%' }}
							imgStyle={{ objectFit: 'contain' }}
							alt={imgAlt}
						/>
					</div>
				</div>
				<div
					className={
						'col-12 col-lg-6 px-xl-5 text-center text-lg-left ' +
						(order && 'order-lg-0 d-flex justify-content-center')
					}
				>
					<div className="col-12 col-xl-9">
						<div className="text-center text-lg-left mt-4">
							<span dangerouslySetInnerHTML={{ __html: sectionTitle }} />
							{!hideHr && (
								<>
									<hr className="my-4 d-none d-lg-block" />
									<hr className="my-4 center d-block d-lg-none" />
								</>
							)}
						</div>
						<div dangerouslySetInnerHTML={{ __html: undertext }} />
						{linkTo && (
							<Link
								to={linkTo}
								className="btn btn-primary green"
								id={btnId}
							>
								{linkText}
							</Link>
						)}
					</div>
				</div>
			</div>
		</>
	);
};

export default ImageTextSection;

